module.exports = __webpack_public_path__ + "static/media/clickInBrain.3073cbd2.wav";